// Mock payment plan model for backward compatibility
export interface PaymentPlan {
    id: string;
    orderId: string;
    amount: number;
    dueDate: Date;
    status: 'pending' | 'completed' | 'overdue';
    installmentNumber: number;
    totalInstallments: number;
}

export interface PaymentPlanItem {
    id: string;
    plan: PaymentPlan;
    user_id: string;
    created_at: Date;
    updated_at: Date;
}

export enum PaymentType {
  PAYSMALL_SMALL = 'pay_small_small',
    INSTALLMENT = 'installment',
  FULL_PAYMENT = 'pay_in_full',
    CREDIT = 'credit',
    
}
